import styled from "styled-components";

  export const ConstantContact = styled.div.attrs((props) => ({
    className: "ConstantContact",
  }))`
    margin: 2rem auto;
    max-width: 1200px;
  `;